// helper which creates specific trigger logic
// it's similar to DOWNLOAD but without the download stuff
import startCase from 'lodash.startcase'
import to from 'await-to-js'

import {
  addRequestAuthentication,
  addRequestFiltering,
  invokeHooks,
  pascalCase,
  promisifyRPC
} from '../utils'

export default ({ actionType, name, config, common }) => {
  let fn = async (context, params) => {
    let { commit, dispatch, state } = context
    // 1) prepare request object
    // - convention: uppercase first letter of name + add 'Request'
    let requestObjectType = `${pascalCase(name)}Request`
    let request = new config.service.import[requestObjectType]()
    // - add authentication
    addRequestAuthentication(config, context, request, common.actionDefinitions[actionType][name].typeMappings)
    // - try to match other fields to allow filters: for example, request by uuid
    addRequestFiltering(config, context, request, params, common.actionDefinitions[actionType][name].typeMappings)
    // - ALLOW HOOK to change something within the request or make a whole new request
    request = await invokeHooks(actionType, 'beforeDataRequest', name, { config, context, request, params })
    // if request is now null - some error happened!
    if (!request) {
      commit('finishedLatestRequest', name)
      return false
    }
    // 2) call API
    // save this request as the latest one (also sets error to null)
    commit('setLatestRequest', {
      name: name,
      masterActiveKey: state.masterActiveKey,
      request: request
    })
    // Invoke RPC and wait for it
    // - need to promisify GPRC call
    // - metadata is not used anywhere?
    let [err, data] = await to(promisifyRPC(config, name, request, context))
    // 3) GOT RESULTS
    if (err) {
      // push the error info into state, maybe we will show it to user
      dispatch('error', {
        message: `${startCase(name)}: Error while retrieving data.`,
        error: err
      })
      commit('setLatestRequestError', { name: name, error: err })
      await invokeHooks(actionType, 'error', name, { config, context, request, params, data: err })
      commit('finishedLatestRequest', name)
      return false
    }
    // extract items from the data object
    // we assume that everything is in place because no err happened
    let responseData = data.toObject()
    // store the whole response in the store
    commit('setLatestResponse', { name, responseData })
    // TODO: implement later, so far we need hook for this because of special handling...
    // // UPDATE ACTIVE ITEM
    // if (config.actions[actionType][name].updateActiveItem) {
    //   let newActiveItem = responseData[config.actions[actionType][name].updateActiveItem.field]
    //   await dispatch('patchItem', newActiveItem)
    // }
    // UPDATE DETAILS LIST
    // TODO: implement once needed
    // call hook if needed
    await invokeHooks(actionType, 'afterDataRequest', name, { config, context, request, params, data: responseData })
    // all done
    commit('finishedLatestRequest', name)
    return true
  }
  return fn
}
